import 'react-app-polyfill/ie9'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { BASE_URL } from './constants'

import configureStore from './store'

import * as serviceWorker from './serviceWorker'

import './index.css'
import './utils.js'
import App from './App'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
  apiKey: '39db8655f584289b6b14275ee0ba6ff8',
  plugins: [new BugsnagPluginReact()],
})
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

const initialState = window.initialReduxState || {}
const store = configureStore(initialState)

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <Router basename={BASE_URL}>
        <App />
      </Router>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
